<template>
	<a-modal
		title="重置密码"
		:width="500"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		:forceRender="true"
		@ok="handleOk"
		@cancel="() => { $emit('cancel') }"
	>
		<a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 15 }">
			<a-form-model-item label="用户">
				<span>{{ userLabel }}</span>
			</a-form-model-item>
			<a-form-model-item label="新密码" prop="password" :rules="passwordRules">
				<a-input-password v-model="form.password" placeholder="至少6位" autocomplete="new-password" />
			</a-form-model-item>
			<a-form-model-item label="确认密码" prop="confirmPassword" :rules="confirmRules">
				<a-input-password v-model="form.confirmPassword" placeholder="再次输入新密码" autocomplete="new-password" />
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
function emptyForm() {
	return {
		password: '',
		confirmPassword: '',
	};
}

export default {
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		user: {
			type: Object,
			default: null,
		},
	},
	data() {
		const validateConfirm = (rule, value, callback) => {
			if (!value) {
				callback(new Error('必填，不能为空'));
				return;
			}
			if (value !== this.form.password) {
				callback(new Error('两次密码不一致'));
				return;
			}
			callback();
		};
		return {
			form: emptyForm(),
			passwordRules: [
				{ required: true, message: '必填，不能为空', trigger: 'blur' },
				{ min: 6, message: '新密码至少6位', trigger: 'blur' },
			],
			confirmRules: [
				{ required: true, validator: validateConfirm, trigger: 'blur' },
			],
		};
	},
	computed: {
		userLabel() {
			if (!this.user) {
				return '-';
			}
			const name = this.user.nickname || this.user.loginAccount || this.user.id;
			return `${name}（ID:${this.user.id}）`;
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.clearValidate();
					}
				});
			}
		},
	},
	methods: {
		handleOk() {
			if (!this.$refs.form || !this.user) {
				return;
			}
			this.$refs.form.validate((valid) => {
				if (!valid) {
					return;
				}
				this.$emit('ok', {
					userId: this.user.id,
					password: this.form.password,
					confirmPassword: this.form.confirmPassword,
				});
			});
		},
	},
};
</script>
